module.exports = __webpack_public_path__ + "img/ic_64_feature_live.95e5c341.svg";